import React, { useCallback, useRef } from 'react';
import { ListItem, Text } from '@rneui/themed';
import BottomSheet, { BottomSheetFlatList } from '@gorhom/bottom-sheet';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from '../../../hooks';
import { BottomSheetBackdrop, FAIcon, useReaderColors } from '../../..';
export const TableOfContents = ({ items: externalItems, onPress = () => { }, size = 30, iconStyle, title = "Table of Contents", }) => {
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const { top, bottom } = useSafeAreaInsets();
    const items = externalItems || [];
    const color = useReaderColors();
    const renderItem = useCallback(({ item, index: idx }) => {
        const isLastItem = items.length - 1 === idx;
        const title = item.title ? item.title : `Chapter ${idx + 1}`;
        return (React.createElement(ListItem, { key: item.href, onPress: () => {
                if (onPress) {
                    onPress(item);
                    bottomSheetRef.current?.close();
                }
            }, bottomDivider: !isLastItem, style: isLastItem
                ? {
                    marginBottom: bottom,
                }
                : undefined },
            React.createElement(ListItem.Content, null,
                React.createElement(ListItem.Title, null, title)),
            item.children &&
                Array.isArray(item.children) &&
                item.children.length > 0 ? (React.createElement(TableOfContents, { items: item.children, size: 30, iconStyle: { color: colors.textPrimary }, onPress: (link) => {
                    onPress(link);
                    bottomSheetRef.current?.close();
                }, title: title })) : null,
            React.createElement(ListItem.Chevron, null)));
    }, [bottom, colors.textPrimary]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FAIcon, { name: "list", size: size, style: iconStyle, color: color.backgroundInverted, onPress: () => bottomSheetRef.current?.snapToIndex(0) }),
        React.createElement(Portal, { hostName: "modal" },
            React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: -1, topInset: top, enablePanDownToClose: true, enableDynamicSizing: false, snapPoints: ['75%', '100%'], backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 3000 } },
                React.createElement(BottomSheetFlatList, { ListHeaderComponent: () => React.createElement(Text, { h4: true, style: { paddingHorizontal: 10 } }, title), data: items, renderItem: renderItem })))));
};
//# sourceMappingURL=TableOfContents.js.map